import { render, staticRenderFns } from "./students-lessons.vue?vue&type=template&id=24cbecfa&"
import script from "./students-lessons.vue?vue&type=script&lang=js&"
export * from "./students-lessons.vue?vue&type=script&lang=js&"
import style0 from "./students-lessons.vue?vue&type=style&index=0&id=24cbecfa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports